import { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet'

type SectionProps = PropsWithChildren<{
  className?: string
  title: string
}>

const Section = ({ title, children, className }: SectionProps) => {
  return (
    <section className={className}>
      <Helmet>
        <title>{title} | wowaudit</title>
      </Helmet>
      <div>{children}</div>
    </section>
  )
}

export default Section
